import { render, staticRenderFns } from "./ChartRenderNew.vue?vue&type=template&id=21fa480f"
import script from "./ChartRenderNew.vue?vue&type=script&lang=ts"
export * from "./ChartRenderNew.vue?vue&type=script&lang=ts"
import style0 from "./ChartRenderNew.vue?vue&type=style&index=0&id=21fa480f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports